const setup = () => {
  document.querySelectorAll('.sidebar .closeBtn').forEach((e) => {
    e.addEventListener('click', (ev: MouseEvent) => {
      const target = ev.target as HTMLElement;
      target.parentElement.style.display = 'none';
    });
  });

  const button = document.getElementById('actionbtn') as HTMLElement;
  button?.addEventListener('click', (ev: MouseEvent) => {
    const btn = ev.target as HTMLElement;
    const target = document.querySelector<HTMLElement>(btn.dataset.sidebar);
    target.style.display = 'block';
  });

  const languagebutton = document.getElementById('languagebtn') as HTMLElement;
  languagebutton?.addEventListener('click', (ev: MouseEvent) => {
    const languagebtn = ev.target as HTMLElement;
    const languageTarget = document.querySelector<HTMLElement>(languagebtn.dataset.languageOptions);
    languageTarget.style.display = 'block';
  });
};

document.addEventListener('DOMContentLoaded', setup);
document.addEventListener('ready', setup);
